export const FLAG_OPTIONS = [
  '',
  'Active',
  'Needs Work',
  'Inactive',
]
